import axios from "axios";

const ENDPOINT =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_SERVICE_URL
    : process.env.REACT_APP_SERVICE_URL_DEV;

export const api = axios.create({
  baseURL: ENDPOINT,
});

// Interceptor para logs de erro
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    console.error("Request URL:", error.config?.url);
    console.error("Base URL:", ENDPOINT);
    return Promise.reject(error);
  }
);
